import { ChangeEmailSection } from "@/components/dashboard/ChangeEmailSection";
import { DisplayNameSection } from "@/components/dashboard/DisplayNameSection";
import { TwoFactorSection } from "@/components/dashboard/TwoFactorSection";

/**
 * Admin → Settings. Minimal for now - just account-level controls.
 * Venue-scoped settings live on the Venues tab. System-wide toggles
 * will go here later as they appear.
 */
export function AdminSettings() {
  return (
    <div>
      <header className="mb-6">
        <p className="mb-1.5 text-xs font-bold uppercase tracking-wider text-volt">
          Admin · Settings
        </p>
        <h1 className="text-3xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Account controls for your admin sign-in.
        </p>
      </header>

      <div className="space-y-5">
        <DisplayNameSection />
        <TwoFactorSection />
        <ChangeEmailSection />
      </div>
    </div>
  );
}
